import { render, staticRenderFns } from "./TagsDLG.vue?vue&type=template&id=64d8b033&scoped=true"
import script from "./TagsDLG.vue?vue&type=script&lang=ts"
export * from "./TagsDLG.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./TagsDLG.vue?vue&type=style&index=0&id=64d8b033&prod&scoped=true&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "64d8b033",
  "00f1358b"
  
)

export default component.exports